// Library
import '@/libs/axios';
import VueCompositionAPI from '@vue/composition-api';
import Vue from 'vue';
import App from './App.vue';
// Internal
import SDGMapWrapper from './components/SDGMapWrapper.vue';

import store from './store';

// import router from './router';

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI);

new Vue({
  // router,
  store,
  render: (h) => h(SDGMapWrapper)
}).$mount('#sdg-map-dashboard');

let vueApp;

// Path pattern: /page-name/params1/params2
const splitPathname = location.pathname.split('/');
const pathname = splitPathname[1];
console.log('pathname', pathname);
if (pathname === 'vue-app') {
  vueApp = new Vue({
    // router,
    store,
    render: (h) => h(App)
  }).$mount('#app');
}

if (vueApp !== undefined) {
  console.log('Vue mounted!!!');
}
